import { render, staticRenderFns } from "./IframeWidgetPreview.vue?vue&type=template&id=24249af6&scoped=true"
import script from "./IframeWidgetPreview.vue?vue&type=script&lang=js"
export * from "./IframeWidgetPreview.vue?vue&type=script&lang=js"
import style0 from "./IframeWidgetPreview.vue?vue&type=style&index=0&id=24249af6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24249af6",
  null
  
)

export default component.exports